<template>
  <div class="lg:px-20 md:px-12 px-5 lg:py-8 md:py-6 py-4">
    <router-link to="/channelpage" >
               <button class="flex items-center sm-fsize14 text-white bg-primary py-2 px-4 rounded-md mb-6">
      <feather-icon
        icon="ArrowLeftIcon"
        class=""
        svgClasses="w-4 h-4 mr-1"
      ></feather-icon>
       Go Back
    </button>
            </router-link>
   
    <div class="lg:flex lg:gap-10 md:gap-6">
      <div class="lg:w-3/5 w-full lg:mb-0 md:mb-8 mb-8">
        <!-- <img
          src="https://nexuscluster.blob.core.windows.net/server01/default/images/default2.jpg"
          alt="img"
          class="h-500px md-h-450px sm-h-250px w-full rounded-xl"
        /> -->
        <iframe
          class="h-500px md-h-450px sm-h-250px w-full rounded-xl object-contain"
          :src="SelectedVideo ? SelectedVideo.video_url + '&autoplay=1' : null"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          id="chintan"
        ></iframe>
        <p
          class="fsize24 sm-fsize20 font-semibold lg:pt-6 md:pt-6 pt-4 text-black"
        >
          {{ SelectedVideo.title }}
        </p>
        <p class="fsize18 sm-fsize14">
          {{ SelectedVideo.description }}
        </p>
      </div>
      <div
        class="lg:w-2/5 w-full grid grid-cols-1 lg:gap-6 md:gap-6 gap-4 overflow-scroll h-90vh"
      >
        <!-- <img
          src="https://nexuscluster.blob.core.windows.net/server01/default/images/default2.jpg"
          alt="img"
          class="h-52 w-full rounded-xl "
        /> -->
        <div
          class="flex gap-4 cursor-pointer"
          v-for="episode of getAllEpisode.result"
          :key="episode._id"
          @click="createHistory(episode)"
        >
          <!-- <iframe
            class="lg:h-48 md:h-48 h-44 w-1/2 rounded-xl"
            src="https://www.youtube.com/embed/_uQrJ0TkZlc"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe> -->
          <img
            class="lg:h-48 md:h-48 h-44 w-1/2 rounded-xl"
            :src="handleFrame(episode.video_url)"
            alt="img"
          />
          <div>
            <p class="fsize20 sm-fsize16 font-semibold text-black">
              {{ episode.title }}
            </p>
            <p class="fsize16-14 lineclamp-2">
              {{ episode.description }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      currentPage: 1,
      editModal: false,
      perPage: 5,
      search: "",
      totalPages: 0,
      SelectedVideo: null,
    };
  },
  watch: {},
  methods: {
    async dataLoad() {
      let curPage = this.currentPage - 1;
      let payload = {
        // limit: this.perPage,
        // offset: curPage * this.perPage,
        // search: "",
        playlistId: this.$route.query.playlistId,
      };

      await this.$store.dispatch("playlist/getall_episode", payload);
      console.log(this.getAllEpisode);
      this.SelectedVideo = this.getAllEpisode.result.length
        ? this.getAllEpisode.result[0]
        : null;
      this.totalPages = this.getAllEpisode.totalCount;
    },
    handlePageChange(value) {
      this.currentPage = value;
      this.dataLoad();
    },
    handleFrame(url) {
      const regex =
        /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
      const match = url.match(regex);
      return `https://img.youtube.com/vi/${match[1]}/hqdefault.jpg`;
    },
    async createHistory(SelectedVideo) {
      this.SelectedVideo = SelectedVideo;

      if (Object.keys(this.user).length <= 0) return;
      let payload = {
        episodeId: SelectedVideo._id,
      };
      try {
        await this.$store.dispatch("playlist/add_history", payload);
        this.dataLoad();
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
    ...mapState("playlist", { getAllEpisode: "getAllEpisode" }),
    ...mapState("auth", { user: "user" }),
  },
  mounted() {
    this.dataLoad();
  },
};
</script>
